import { cn } from "@/lib/utils";

type TCtaMessage = {
  message?: string;
};

export function FormMessage({ message }: TCtaMessage) {
  if (!message) return null;
  return (
    <span
      className={cn(
        "block",
        "xl:top-28",
        "lg:top-28",
        "top-38",
        "left-0",
        "absolute",
        "bg-white",
        "rounded",
        "shadow",
        "p-4",
        "transition-all",
        "duration-300",
        "text-secondary"
      )}
    >
      {message}
    </span>
  );
}
